// /en/cloud: fanene og tidskalkulatoren (Sjur 04.11.2026, ts 1793786461). Sjurs cloud-en.js, ordrett.
(function(){
  var faner=document.querySelectorAll('.sa-fane'),skjermer=document.querySelectorAll('.sa-skjerm');
  faner.forEach(function(f,i){f.addEventListener('click',function(){
    faner.forEach(function(a,n){a.setAttribute('aria-selected',n===i?'true':'false')});
    skjermer.forEach(function(a,n){a.hidden=n!==i});
  })});
  var fmt=new Intl.NumberFormat('en-GB');
  function v(id){var n=parseFloat(document.getElementById(id).value);return isNaN(n)||n<0?0:n}
  function regn(){
    var andel=v('dk-andel')/100,uke=v('dk-pers')*v('dk-timer')*andel,aar=uke*46;
    var kr=Math.round(aar*v('dk-pris')/1000)*1000;
    document.getElementById('dk-andel-vis').textContent=v('dk-andel')+'%';
    document.getElementById('dk-r-uke').textContent=fmt.format(Math.round(uke*10)/10)+' hours';
    document.getElementById('dk-r-aar').textContent=fmt.format(Math.round(aar));
    document.getElementById('dk-r-kr').textContent='NOK '+fmt.format(kr);
  }
  document.getElementById('dk-kalk').addEventListener('input',regn);
  regn();
})();
